import { IonIcon } from "@ionic/react";
import { cloudUploadOutline, logoFacebook } from "ionicons/icons";
import { useContext, useRef, useState } from "react";
import { useOutletContext } from "react-router";
import styled, { css } from "styled-components";
import { uploadLogo } from "../../services/UserLogoService.js";
import WorkspaceContext from "../WorkSpace/WorkspaceContext.js";
import Button from "./ActionButton.jsx";
import { Input } from "./InputStyle.jsx";
import Loading from "./Loading.jsx";
import Switch from "./Switch.jsx";
import { PAYMENT_METHODS } from "./PaymentMethodsList.jsx";
const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

const Form = styled.div`
  display: flex;
  gap: 7.2rem;

  ${({ flex }) =>
    flex
      ? css`
          flex-direction: ${flex};
          gap: 4.8rem;
          width: 100%;
          padding: 0 7%;
        `
      : ""}
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  input {
    margin-bottom: 2.4rem;
  }
`;

const WrapperTitle = styled.span`
  font-size: 1.8rem;
  margin-bottom: 1.8rem;
  display: inline-block;
  text-transform: capitalize;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
`;
const LogoInput = styled.input`
  all: unset;
  width: 100%;
  height: 100%;
  opacity: 0;
  position: relative;
  border-radius: 50px;
`;

const LogoButton = styled.div`
  width: 10rem;
  height: 10rem;

  cursor: pointer;
  border-radius: 2px;
  position: relative;
  ${({ logo }) => {
    return logo
      ? css`
          background-image: url(${logo}) !important;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          border: 1px solid #d9d9d9;
          .icon {
            display: none;
          }
        `
      : "background-color: #d9d9d9;";
  }}
  .icon {
    font-size: 2.4rem;
    color: black;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
  }
`;
const Span = styled.span`
  font-size: 1.4rem;
  text-align: center;
  gap: 0.6rem;

  &.remove-logo {
    transition: all 300ms ease-in-out;
    text-transform: capitalize;
    cursor: pointer;
  }

  &.remove-logo:hover {
    color: #dc2626;
  }
`;

/* DELIVERY AND PAYMENT METHODS */
const PaymentOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1.6rem;
`;

const PaymentOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.6rem 0;
  width: 100%;
  .label {
    font-size: 1.4rem;
    text-transform: capitalize;
  }
`;

const DeliveryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.2rem;
  width: 100%;
  .label {
    font-size: 1.4rem;
    text-transform: capitalize;
  }
`;

// add payment methods constant

//COMPONENT VERIFIED 31/05
export default function MarcaForm({ flex }) {
  const { userBrand, onUserBrandChange } = useContext(WorkspaceContext);
  const { user, token } = useOutletContext();
  const [wasBrandUpdated, setWasBrandUpdated] = useState(false);
  const [loadingLogo, setLoadingLogo] = useState(false);
  const logoButton = useRef();
  const updateInfo = (type, e) => {
    setWasBrandUpdated(true);
    const data = e.target.getAttribute("data-info");
    const brandCopy = { ...userBrand };
    if (type !== "") {
      brandCopy[type][data] = e.target.value;
    } else brandCopy[data] = e.target.value;
    onUserBrandChange(brandCopy);
  };

  const togglePaymentMethod = (methodId, enabled) => {
    setWasBrandUpdated(true);
    const brandCopy = { ...userBrand };
    const arr = Array.isArray(brandCopy.paymentMethods)
      ? [...brandCopy.paymentMethods]
      : [];
    const idx = arr.indexOf(methodId);

    if (typeof enabled === "boolean") {
      // explicit set
      if (enabled && idx === -1) arr.push(methodId);
      if (!enabled && idx !== -1) arr.splice(idx, 1);
    } else {
      // fallback toggle behavior
      if (idx === -1) arr.push(methodId);
      else arr.splice(idx, 1);
    }

    brandCopy.paymentMethods = arr;
    onUserBrandChange(brandCopy);
  };

  const toggleDelivery = (enabled) => {
    setWasBrandUpdated(true);
    const brandCopy = { ...userBrand };
    if (typeof enabled === "boolean") brandCopy.deliveryAvailable = enabled;
    else brandCopy.deliveryAvailable = !Boolean(brandCopy.deliveryAvailable);
    onUserBrandChange(brandCopy);
  };

  const hasPaymentMethod = (methodId) =>
    Array.isArray(userBrand?.paymentMethods) &&
    userBrand.paymentMethods.includes(methodId);

  const submitLogo = async () => {
    const files = document.getElementById("fileInput").files;
    const name = `${user.email}_LOGO.${files[0].type.split("/")[1]}`;
    const file = new File([files[0]], name, { type: files[0].type });
    await uploadLogo(file, user.email, token);
    const brandCopy = { ...userBrand };
    const fr = new FileReader();
    fr.readAsDataURL(files[0]);
    fr.onloadend = (ev) => {
      brandCopy.logoURLTmp = ev.target.result;
    };
    alert(
      "Talvez você precise recarregar a página para as mudanças serem efetivas."
    );
    onUserBrandChange(brandCopy);
  };

  const saveBrandUpdates = async () => {
    const userCopy = { ...user };
    userCopy.brand = userBrand;
    const url = `${BASE_URL}user-collection/${user.id}`;
    const res = await fetch(url, {
      method: "PUT",
      headers: { Authorization: token, "Content-Type": "application/json" },
      body: JSON.stringify(userCopy),
    });
    if (res.ok) {
      alert("Alterações salvas");
      setWasBrandUpdated(false);
    }
  };

  return (
    <Form flex={flex}>
      {userBrand && (
        <>
          <InputWrapper>
            <IonIcon className="logo" logo={logoFacebook} size="small" />
            <WrapperTitle>Identidade</WrapperTitle>
            <Input
              data-info="name"
              placeholder="nome da empresa"
              value={userBrand.name || ""}
              onChange={(e) => updateInfo("", e)}
            />
            <Input
              data-info="phrase"
              placeholder="bordão"
              value={userBrand.phrase || ""}
              onChange={(e) => updateInfo("", e)}
            />
            <Wrapper>
              <LogoButton
                ref={logoButton}
                className="button"
                logo={userBrand.logoURLTmp}
              >
                <IonIcon icon={cloudUploadOutline} className="icon" />
                <>
                  {loadingLogo ? (
                    <Loading />
                  ) : (
                    <LogoInput
                      type="file"
                      id="fileInput"
                      onChange={submitLogo}
                    />
                  )}
                </>
              </LogoButton>

              <Span>
                Clique para selecionar <br></br> sua logomarca
              </Span>
            </Wrapper>
          </InputWrapper>
          <InputWrapper
            onChange={(e) => {
              updateInfo("address", e);
            }}
          >
            <WrapperTitle>localização</WrapperTitle>

            <Input
              data-info="number"
              defaultValue={userBrand.address.number}
              placeholder="número"
            />
            <Input
              data-info="street"
              defaultValue={userBrand.address.street}
              placeholder="rua/avenida"
            />
            <Input
              data-info="neighborhood"
              defaultValue={userBrand.address.neighborhood}
              placeholder="bairro"
            />
            <Input
              data-info="city"
              defaultValue={userBrand.address.city}
              placeholder="cidade"
            />

            <DeliveryRow>
              <span className="label">Realizam entrega?</span>
              <Switch
                on={Boolean(userBrand.deliveryAvailable)}
                callback={(val) => toggleDelivery(val)}
              />
            </DeliveryRow>
          </InputWrapper>
          <InputWrapper
            onChange={(e) => {
              updateInfo("social", e);
            }}
          >
            <WrapperTitle>Mídias Sociais</WrapperTitle>
            <Input
              data-info="whatsapp"
              defaultValue={userBrand.social.whatsapp}
              placeholder={`Whatsapp`}
            />
            <Input
              data-info="instagram"
              defaultValue={userBrand.social.instagram}
              placeholder="Instagram"
            />
            <Input
              data-info="facebook"
              defaultValue={userBrand.social.facebook}
              placeholder="Facebook"
            />
            <Input
              data-info="website"
              defaultValue={userBrand.social.website}
              placeholder="Website"
            />
            <WrapperTitle>Formas de pagamento</WrapperTitle>
            <PaymentOptionsContainer>
              {PAYMENT_METHODS.map((pm) => (
                <PaymentOption key={pm.id}>
                  <span className="label">{pm.label}</span>
                  <Switch
                    on={hasPaymentMethod(pm.id)}
                    callback={(val) => togglePaymentMethod(pm.id, val)}
                  />
                </PaymentOption>
              ))}
            </PaymentOptionsContainer>

            {wasBrandUpdated ? (
              <Button
                action={saveBrandUpdates}
                text="salvar alterações"
                $fullWidth
              />
            ) : (
              <Button
                action={() => {}}
                text="salvar alterações"
                $fullWidth
                $NoBgColor
                color={"fff"}
              />
            )}
          </InputWrapper>
        </>
      )}
    </Form>
  );
}
